/*
 * oi-bis.js — Back-in-Stock notify ("Notify me when back in stock").
 * Renders on sold-out variants via snippets/oi-buy-buttons.liquid. Click reveals an email
 * field; submit POSTs to Klaviyo's client back-in-stock endpoint for the selected variant.
 * company_id + variant id come from data-* attrs. Klaviyo returns 202 (no body) on success.
 * The product section re-renders per variant (product-info.js), so a fresh <oi-bis> upgrades
 * automatically each time a sold-out variant is selected — the element only needs defining once.
 */
(function () {
  if (customElements.get('oi-bis')) return;

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  class OIBackInStock extends HTMLElement {
    connectedCallback() {
      this.openBtn = this.querySelector('.oi-bis__open');
      this.form = this.querySelector('.oi-bis__form');
      this.email = this.querySelector('.oi-bis__email');
      this.msg = this.querySelector('.oi-bis__msg');
      this.success = this.querySelector('.oi-bis__success');
      if (this.openBtn) this.openBtn.addEventListener('click', () => this._open());
      if (this.form) this.form.addEventListener('submit', (e) => this._submit(e));
    }

    _open() {
      if (this.openBtn) this.openBtn.hidden = true;
      if (this.form) this.form.hidden = false;
      if (this.email) this.email.focus();
    }

    _msg(text, isError) {
      if (!this.msg) return;
      this.msg.hidden = false;
      this.msg.textContent = text;
      this.msg.classList.toggle('oi-bis__msg--error', !!isError);
    }

    _done() {
      if (this.form) this.form.hidden = true;
      if (this.msg) this.msg.hidden = true;
      if (this.success) this.success.hidden = false;
    }

    _submit(e) {
      e.preventDefault();
      var email = (this.email && this.email.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        this._msg('Please enter a valid email address.', true);
        if (this.email) this.email.focus();
        return;
      }

      var companyId = this.getAttribute('data-company-id');
      var variantId = this.getAttribute('data-variant-id');
      var btn = this.form.querySelector('.oi-bis__submit');
      if (btn) btn.disabled = true;
      this._msg('', false);
      if (this.msg) this.msg.hidden = true;

      // Not configured → confirm optimistically so the demo never looks broken.
      if (!companyId || !variantId) {
        if (btn) btn.disabled = false;
        this._done();
        return;
      }

      // Client-provided BIS list (08-11): also add the signup to this Klaviyo list so a
      // LIST-triggered flow sees them too (the back-in-stock subscription below only feeds
      // metric-triggered flows). Fire-and-forget; the BIS call decides the UI outcome.
      var bisListId = this.getAttribute('data-bis-list-id');
      if (bisListId) {
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'Back in Stock Notify'
            }, relationships: { list: { data: { type: 'list', id: bisListId } } } } })
          });
        } catch (err) { /* non-blocking */ }
      }

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: { variant: { data: {
            type: 'catalog-variant',
            id: '$shopify:::$default:::' + variantId
          } } }
        } })
      }).then((res) => {
        if (btn) btn.disabled = false;
        if (res.ok) { this._done(); }
        else { this._msg('Something went wrong. Please try again.', true); }
      }).catch(() => {
        if (btn) btn.disabled = false;
        this._msg('Something went wrong. Please try again.', true);
      });
    }
  }

  customElements.define('oi-bis', OIBackInStock);
})();
